/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { ClickAwayListener, IconButton, Paper, Popper } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Theme } from '@mui/material/styles';

import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars
const styles = (theme: Theme) => {
	return createStyles({
		button: {
			padding: 0
		}
	});
};

type Props = React.PropsWithChildren<object> & WithStyles<typeof styles>;

interface State {
	anchorEl: HTMLElement | null;
}

class CategoryInfoView extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			anchorEl: null
		};
	}

	toggleAnchor(target: HTMLElement | null): void {
		this.setState({ anchorEl: this.state.anchorEl ? null : target });
	}

	render(): JSX.Element {
		const { classes } = this.props;
		const { anchorEl } = this.state;
		return (
			<ClickAwayListener
				mouseEvent="onMouseDown"
				onClickAway={(): void => {
					this.toggleAnchor(null);
				}}
			>
				{/* wrapper is required for ClickAwayListener */}
				<span>
					<IconButton
						className={classes.button}
						onMouseDown={(event): void => {
							this.toggleAnchor(event.currentTarget);
						}}
						onKeyDown={(event): void => {
							if (['Enter', ' '].includes(event.key)) {
								this.toggleAnchor(event.currentTarget);
							}
						}}
						size="large"
					>
						<InfoIcon />
					</IconButton>
					<Popper open={!!anchorEl} anchorEl={anchorEl} placement="bottom-end">
						<Paper elevation={8}>{this.props.children}</Paper>
					</Popper>
				</span>
			</ClickAwayListener>
		);
	}
}

export default withStyles(styles)(CategoryInfoView);
